import { t } from "i18next"
import dayjs from "dayjs"
import { capitalizeFirstLetter, convertToReadableString, localisedValue } from "utils"
import { createPrivilegeObject } from "utils/privileges/privilegesMapper"

const marketingCallRecordingTransformHelper = response => {
  const { all, ...params } = response?.typeWiseCount
  return {
    ...response,
    phoneCallRecords: response?.data?.map(e => {
      let convertedDate = dayjs.utc(e?.initiatedAt).local()
      return {
        ...e,
        date: convertedDate,
        phoneCallId: e?.id,
        time: convertedDate,
        staff: { id: e?.User?.id, name: localisedValue({object: e?.User, key: "name" }), callBy: convertToReadableString(e?.source)},
        client: { 
            id: e?.ExternalInquiry?.id, 
            name: localisedValue({object: e?.ExternalInquiry , key:"clientName"}),
            email: e?.ExternalInquiry?.clientEmail,
            country:{...e?.ExternalInquiry?.ClientCountry, loc_code:e?.ExternalInquiry?.ClientCountry?.locCode },
            countryName: localisedValue({object: e?.ExternalInquiry?.ClientCountry , key: "name"}),
            cityName: localisedValue({object: e?.ExternalInquiry?.ClientCity, key: "name"}),
            campaign: e?.ExternalInquiry?.SocialPlatformCampaign?.campaignName,
            platform: localisedValue({object: e?.ExternalInquiry?.SocialPlatformCampaign?.SocialPlatform , key: "title"})
        },
        tag: { title: e?.PhoneCallTag?.abbreviation, color: e?.PhoneCallTag?.style?.bgColor, tooltipTitle: localisedValue({object: e?.PhoneCallTag, key: "title"}) },
        recording: e?.url,
        assessment: {
          scoring: {
            total_score : e?.aiScore,
          }
        },
        userId: e?.User?.id,
        assessmentStatus: capitalizeFirstLetter(e?.aiStatus) ?? null,
        analysisStatus: e?.aiStatus,
        duration: e?.connectedDuration,
        callType: e?.type,
        userName: localisedValue({object: e?.User, key:"name"}),
        tagShort:e?.PhoneCallTag?.abbreviation,
        tagStyle: {bgColor: e?.PhoneCallTag?.style?.bgColor},
        callBy:convertToReadableString(e?.source),
        leadQualificationStatus: convertToReadableString(e?.summary?.status)
      }
    }),
    phoneCallRecordsStatistics: { all, in: params.in, out: params.out },
    callTabNames: { out: t("Outgoing"), in: t("Incoming"), all: t("All") },
  }
}

export default marketingCallRecordingTransformHelper